/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class MoeAuditTermAttendanceRegisterRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: true,
    },
    dateTo: {
      refreshModel: true,
    },
  };

  // Services
  @service
  session;

  @service
  store;

  // State
  dateFrom = moment().format('YYYY-01-01');

  dateTo = moment().format('YYYY-12-31');

  model(params) {
    let dateFrom = params.dateFrom || this.dateFrom;
    let dateTo = params.dateTo || this.dateTo;
    let year = moment(dateFrom).year();
    let schoolId = this.get('session.activeSchool');

    return hash({
      dates: this.store.query('date', {
        schoolId,
        year,
      }),
      nzMoeDays: this.store.query('attendance/nz-moe-day', {
        dateFrom,
        dateTo,
      }),
      people: this.store.query('person', {
        includeFormer: true,
        type: PersonType.LEARNER,
      }),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
    });
  }
}
